import { useQuery } from '@tanstack/react-query';
import { PairName } from '@ui/assets/config/trade-pair-listings';
import { Interval } from '@ui/constants/poll';
import { useDataChainId } from '@ui/hooks/datachain';
import { FALLBACK_ADDRESS } from '@ui/services/contract/constants';
import { BareTradePair } from '@ui/types/tradePair';
import type { Address } from 'viem';
import { useAccount, usePublicClient } from 'wagmi';

import { getLimitOrdersBatchQuery } from './query';

export const useGetLimitOrdersBatch = ({
  pairs,
  interval,
  userAddress,
}: {
  pairs: Record<PairName, BareTradePair> | undefined;
  interval?: Interval;
  userAddress?: Address;
}) => {
  const chainId = useDataChainId();
  const client = usePublicClient({
    chainId,
  });
  const { address } = useAccount();

  return useQuery({
    refetchInterval: interval,
    refetchOnMount: true,
    enabled: !!(userAddress ?? address) && !!client && !!pairs,
    queryKey: getLimitOrdersBatchQuery.getQueryKey({
      chainId,
      clientUid: client?.uid ?? '',
      pairs,
      user: userAddress ?? address ?? FALLBACK_ADDRESS,
    }),
    queryFn: getLimitOrdersBatchQuery.getQueryFn({
      chainId,
      client,
      pairs,
      user: userAddress ?? address ?? FALLBACK_ADDRESS,
    }),
  });
};
